"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RowBelow_exports = {};
__export(RowBelow_exports, {
  default: () => RowBelow_default
});
module.exports = __toCommonJS(RowBelow_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 3C6.22386 3 6 3.22386 6 3.5V7.5C6 7.77614 6.22386 8 6.5 8H12.5C12.7761 8 13 7.77614 13 7.5V3.5C13 3.22386 12.7761 3 12.5 3H6.5ZM7 7V4H12V7H7ZM6.5 9.5C6.22386 9.5 6 9.72386 6 10V14C6 14.2761 6.22386 14.5 6.5 14.5H12.5C12.7761 14.5 13 14.2761 13 14V10C13 9.72386 12.7761 9.5 12.5 9.5H6.5ZM7 13.5V10.5H12V13.5H7ZM14 3.5C14 3.22386 14.2239 3 14.5 3H20.5C20.7761 3 21 3.22386 21 3.5V7.5C21 7.77614 20.7761 8 20.5 8H14.5C14.2239 8 14 7.77614 14 7.5V3.5ZM15 4V7H20V4H15ZM14.5 9.5C14.2239 9.5 14 9.72386 14 10V14C14 14.2761 14.2239 14.5 14.5 14.5H20.5C20.7761 14.5 21 14.2761 21 14V10C21 9.72386 20.7761 9.5 20.5 9.5H14.5ZM15 13.5V10.5H20V13.5H15ZM6.5 16C6.22386 16 6 16.2239 6 16.5V20.5C6 20.7761 6.22386 21 6.5 21H12.5C12.7761 21 13 20.7761 13 20.5V16.5C13 16.2239 12.7761 16 12.5 16H6.5ZM14.5 16C14.2239 16 14 16.2239 14 16.5V20.5C14 20.7761 14.2239 21 14.5 21H20.5C20.7761 21 21 20.7761 21 20.5V16.5C21 16.2239 20.7761 16 20.5 16H14.5ZM3.91603 16.7227C3.79381 16.5394 3.56599 16.4576 3.35511 16.5215C3.14423 16.5853 3 16.7797 3 17V20C3 20.2204 3.14423 20.4147 3.35511 20.4786C3.56599 20.5424 3.79381 20.4607 3.91603 20.2774L4.91603 18.7774C5.02799 18.6094 5.02799 18.3906 4.91603 18.2227L3.91603 16.7227Z",
      fill: "currentColor"
    }
  )
);
const SvgRowBelow = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var RowBelow_default = SvgRowBelow;
